<template>
  <pre>ViewBrowser dataObj: {{dataObj}}</pre>
  <pre>ViewBrowser returnData: {{returnData}}</pre>
</template>
<script>
import BlockAdresa from "@/components/general/view/blocks/BlockAdresa";
import BlockCena from "@/components/general/view/blocks/BlockCena";
export default {
  name: "ViewBrowser",
  components: {
    BlockCena,
    BlockAdresa,
  },
  props: {
    "dataObj": Object,
    "returnData": [Object, String, Number],
  },
  data() {
    return {
      source: 'promena source',
      inputModel: null,
    }
  },
  mounted() {

  },
  methods: {
  },
  watch: {

  },
};
</script>